module.exports = __webpack_public_path__ + "8f4fc74ba8c68c146331a4e4c58a06bf.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/hand/stethescope-s.png
// module id = 2126
// module chunks = 0